import * as React from "react";
const SvgFiRrEject = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-eject_svg__a)">
      <path
        fill="#062147"
        d="M24 21a1 1 0 0 1-1 1H1a1 1 0 0 1 0-2h22a1 1 0 0 1 1 1M.432 15.809a4 4 0 0 1-.44-1.818c0-.843.27-1.657.783-2.355l8.059-9.074C9.536 1.597 10.71 1 12 1c1.272 0 2.434.581 3.195 1.595l7.963 8.969c.968 1.312 1.096 2.871.4 4.245A3.93 3.93 0 0 1 19.993 18H4a3.93 3.93 0 0 1-3.568-2.191m1.56-1.818c0 .312.076.62.225.914A1.94 1.94 0 0 0 4 16h15.993c.78 0 1.43-.399 1.783-1.095a1.94 1.94 0 0 0-.171-2.085L13.61 3.817A1.98 1.98 0 0 0 12 3c-.644 0-1.231.298-1.611.817l-8.06 9.076c-.2.28-.337.684-.337 1.098"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-eject_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEject;
